<template>
  <base-model :show="!!error" title="An error occurred" @close="handleError">
    <p>{{ error }}</p>
  </base-model>
  <base-model :show="isLoading" title="Loading..." fixed>
    <base-spinner></base-spinner>
  </base-model>
  <div class="controls">
    <ul class="btns">
      <li><base-button to="/newProject" link>New Project</base-button></li>
      <li><base-button @click="loadProjects">Refresh Project</base-button></li>
    </ul>
  </div>
  <div>
    <ul class="projects">
      <ProjectItem
        v-for="project in projects"
        :key="project.projectId"
        :id="project.projectId"
        :name="project.projectName"
        :desc="project.description"
        :type="project.type"
        :mode="project.mode"
        :date="project.date"
      ></ProjectItem>
    </ul>
  </div>
</template>

<script>
import ProjectItem from "../components/home/ProjectItem.vue";
export default {
  data() {
    return {
      error: null,
      isLoading: false,
    };
  },
  components: {
    ProjectItem,
  },
  computed: {
    projects() {
      return this.$store.getters["projects/getAllProjects"];
    },
  },
  created() {
    this.loadProjects();
  },
  methods: {
    async loadProjects() {
      this.isLoading = true;
      try {
        await this.$store.dispatch("projects/setProjects");
      } catch (err) {
        this.error = err.message || "Failed to load Project Try again";
      }
      this.isLoading = false;
    },
    handleError() {
      this.error = null;
    },
  },
};
</script>

<style scoped>
.projects {
  margin: 0px;
  padding: 0px;
  list-style: none;
  width: 100%;
  text-align: center;
  float: left;
}
.controls {
  float: left;
  width: 100%;
  text-align: left;
  margin-top: 20px;
  padding: 0px 20px;
  box-sizing: border-box;
}
.btns {
  list-style: none;
  margin: 0px;
  padding: 0px;
}
.btns li {
  display: inline-block;
}
</style>
